import { useRef, useState, useMemo } from 'react';
import { Stack } from '@mui/material';
import { DetailForm } from './detail-form';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import useToast from 'src/utils/toast-utils';
import PageSection from 'src/layouts/page-section';
import { useCallbackAction } from 'src/hooks/use-actions';

import useCensor from 'src/api/censors/vm-form';
import useTicket from 'src/api/tickets/vm-form';

const Page = ({ onNavigate, item, onReload }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const myId = useMemo(() => item.id || '');
  const [localItem, setLocalItem] = useState(item);
  
  const { toastError, toastSuccess } = useToast();
  const { updateTmsItem, sendTmsTicket } = useCensor();
  const { deleteTicket } = useTicket();

  const apiUpdate = (values) => useCallbackAction(updateTmsItem, values,
    (result) => {
      toastSuccess(`Đã kiểm ${result}`, onReload ? undefined : { action: 'back' });
      if (onReload) onReload();
    }, toastError);

  const apiSendTicket = (values) => useCallbackAction(sendTmsTicket, values, 
    (result) => {
      toastSuccess(`Đã gửi thông báo ${result}`, onReload ? undefined : { action: 'back' });
      if (onReload) onReload();
    }, toastError);

  const apiUnsendTicket = (values) => useCallbackAction(deleteTicket, values, 
    (result) => {
      toastSuccess(`Đã hủy thông báo ${result}`);

      // Referesh item remove ticket object
      delete item.ticket;
      setLocalItem(item);
    }, toastError);
  
  if (myId === 0) {
    onNavigate?.(); // safely call
    return null;
  }
  
  return (
    <PageSection title="Tms" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.tms)}
          subLabel={myId}
        />
        <DetailForm item={localItem} apiUpdate={apiUpdate} 
          apiSendTicket={apiSendTicket} apiUnsendTicket={apiUnsendTicket} />
      </Stack>
    </PageSection>
  );
};

export default Page;
